<template>
    <v-container fluid class="pa-0">
        <v-overlay :value="isLoading" style="z-index: 1002">
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <l-map ref="map" :style="mapCSS()" :zoom="zoom" :minZoom="6" :center="[center.lat, center.lng]" @baselayerchange="baselayerChanged" @update:zoom="zoomUpdated" @update:center="centerUpdated" :options="{ zoomControl: false, preferCanvas: true }">
            <l-tile-layer v-for="tileProvider in tileProviders" :key="tileProvider.name" :name="tileProvider.name" :visible="tileProvider.visible" :url="tileProvider.url" layer-type="base" :attribution="tileProvider.attribution" />
            <l-control-scale position="bottomright" :imperial="false"></l-control-scale>
            <l-control-zoom position="bottomright"></l-control-zoom>
            <l-control-layers position="bottomright"></l-control-layers>
            <l-control position="bottomright">
                <v-btn elevation="0" color="transparent" class="pa-0" min-width="48" href="/manuals/m001.pdf" target="_blank" rel="noopener noreferrer">
                    <v-img :src="iconManual" width="48" height="48" contain />
                </v-btn>
            </l-control>
            <!-- ---------------- -->
            <l-geo-json :geojson="geojson" :options="geoOptions"></l-geo-json>
            <!-- ---------------- -->
            <l-control position="topleft">
                <div class="d-flex flex-row">
                    <v-menu ref="menuCalendar" v-model="dispCalender" :close-on-content-click="false" nudge-top="25" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <div style="width: 120px">
                                <v-text-field label="日付" solo dense background-color="grey lighten-3" v-model="targetDateText" readonly v-bind="attrs" v-on="on"></v-text-field>
                            </div>
                        </template>
                        <v-date-picker v-model="dPicker" @change="commitCalendar(dPicker)" locale="jp" :max="maxDate" :day-format="(date) => new Date(date).getDate()" scrollable></v-date-picker>
                    </v-menu>
                    <v-select style="width: 150px; z-index: 1000" class="mx-3" background-color="grey lighten-3" dense outlined label="検出フィルタ" v-model="detectFilter" :items="detectFilterItem" @change="dispCircle()">
                        <template v-slot:item="{ item, on, attrs }">
                            <v-list-item ripple v-bind="attrs" v-on="on">
                                <v-list-item-icon style="margin-right: 3px">
                                    <v-img :src="item.icon" max-width="20" max-height="20" contain />
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <template v-slot:selection="{ item }">
                            <v-img :src="item.icon" max-width="20" max-height="20" contain class="mr-2" />
                            <span>{{ item.text }}</span>
                        </template>
                    </v-select>
                </div>
            </l-control>
            <!-- ---------------- -->
            <l-control position="topright">
                <v-btn elevation="3" @click.stop="drawer = !drawer">
                    <v-icon color="grey darken-3">mdi-cog</v-icon>
                </v-btn>
            </l-control>
            <!-- ---------------- -->
            <div v-if="showMesh">
                <l-polygon v-show="showMesh" v-for="(p, idx) in polygons" :key="'PL' + idx" :lat-lngs="p.latlngs" color="grey" :weight="1.0" :opacity="0.7" :fill-color="p.color" :fill-opacity="p.opacity"></l-polygon>
            </div>
            <div v-show="showCircle">
                <l-circle-marker z-index="1004" v-for="(circle, idx) in circles" :key="'circle-' + idx" :lat-lng="circle.center" :radius="circle.radius" :color="circle.color" :fill-color="circle.fillColor" :fill-opacity="circle.fillOpacity" :weight="circle.weight">
                </l-circle-marker>
            </div>
            <!-- ---------------- -->
            <div v-if="showMarker">
                <l-marker :z-index-offset="1009" v-for="(p, idx) in markers" :key="'M' + idx" :lat-lng="[p.gps_latitude, p.gps_longitude]">
                    <l-popup :options="{ minWidth: 100 }">
                        <h2>{{ p.name }}</h2>
                        <v-divider class="my-1"></v-divider>
                        <h4>Model : {{ p.model }}</h4>
                        <h4>IMEI : {{ p.imei }}</h4>
                        <!--<h4>SIM : {{ p.sim }}</h4>-->
                        <h4 v-show="p.last_received_at">Alive : {{ $moment(p.last_received_at).format("YYYY-MM-DD HH:ss") }}</h4>
                        <h4>GPS : {{ p.gps_latitude }}, {{ p.gps_longitude }}</h4>
                        <v-divider class="my-1"></v-divider>
                        <h4>撮影数傾向</h4>
                        <v-sparkline :max="100" :value="p.shotAry" fill color="purple lighten-3" :smooth="20"></v-sparkline>
                        <!--
                        <v-divider class="my-1"></v-divider>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th width="60%">日時</th>
                                        <th width="40%">枚数</th>
                                        <th width="20%">シカ</th>
                                        <th width="20%">イノシシ</th>
                                        <th width="20%">クマ</th>
                                        <th width="20%">サル</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(dtct, idx) in p.ai_detect" :key="'DTCT' + idx">
                                        <td>{{ dtct.shot_date }}</td>
                                        <td>{{ dtct.shot }}</td>
                                        <td>{{ dtct.max_deer }}</td>
                                        <td>{{ dtct.max_boar }}</td>
                                        <td>{{ dtct.max_bear }}</td>
                                        <td>{{ dtct.max_monkey }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                        -->
                        <v-divider class="my-1"></v-divider>
                        <v-btn class="mx-1" v-show="true" color="success" @click="openDialog(p.id)">
                            <v-icon>mdi-format-align-left</v-icon>
                        </v-btn>
                        <v-btn class="mx-1" v-show="true" color="info" :to="{ name: 'Playback', params: { device_id: p.id, target_date: $moment(targetDate).format('YYYY-MM-DD') }, query: { detect: detectFilter } }">
                            <v-icon>mdi-camera</v-icon>
                        </v-btn>
                    </l-popup>
                </l-marker>
            </div>
            <!-- ========================================================= -->
            <v-navigation-drawer app temporary dark v-model="drawer" right absolute style="z-index: 1001" class="indigo lighten-1" height="auto">
                <v-list>
                    <v-subheader>表示設定</v-subheader>
                    <v-list-item>
                        <v-list-item-content>
                            <div><v-switch dense color="orange" class="mx-5 my-0" v-model="showMarker" label="ピン表示" @change="dispMarker()"></v-switch></div>
                            <div v-show="showMarker">
                                <v-select dense outlined v-model="selectDevices" :items="optDevices" label="デバイスフィルター" @change="dispMarker()"></v-select>
                            </div>
                            <div v-show="false"><v-switch dense color="orange" class="mx-5 my-0" v-model="showCircle" label="サークル表示" @change="dispCircle()"></v-switch></div>
                            <div v-show="false">
                                <v-select dense outlined label="検出フィルタ" v-model="detectFilter" :items="detectFilterItem" @change="dispCircle()"></v-select>
                                <v-select dense outlined label="検出数" v-model="detectCount" :items="detectCountItem" v-show="false"></v-select>
                            </div>
                            <div v-show="false">
                                <div><v-switch dense color="orange" class="mx-5 my-0" v-model="showHeatmap" label="ヒートマップ表示" @change="dispHeatmap()"></v-switch></div>
                                <div><v-switch dense color="orange" class="mx-5 my-0" v-model="showMesh" label="メッシュ表示" @change="dispMesh()"></v-switch></div>
                                <div v-show="showMesh">
                                    <v-select dense v-model="selectMeshLevel" :items="optMeshLevel" label="メッシュレベル" outlined @change="dispMesh()"></v-select>
                                </div>
                            </div>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
            <!-- ========================================================= -->
            <v-dialog v-model="dialog" scrollable fullscreen style="z-index: 1002">
                <v-card>
                    <v-card-title class="indigo">
                        <h3 class="yellow--text">{{ dialogInfo.name }}</h3>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="grey lighten-2 pa-0">
                        <comp-detect-summary :device-id="dialogInfo.id" :target-date="targetDate"></comp-detect-summary>
                        <comp-shot-log v-if="false" :device_id="dialogInfo.id"></comp-shot-log>
                    </v-card-text>
                    <v-divider></v-divider>
                </v-card>
            </v-dialog>
            <!-- ========================================================= -->
        </l-map>
    </v-container>
</template>

<style></style>

<script>
import JWT from "jsonwebtoken";
import CompShotLog from "@/components/CompShotLog.vue";
import CompDetectSummary from "@/components/CompDetectSummary.vue";
import { japanmesh } from "japanmesh";
import { LMap, LTileLayer, LMarker, LControl, LPopup, LControlZoom, LControlScale, LControlLayers, LPolygon, LGeoJson, LCircleMarker } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

import L from "leaflet";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    markerColor: "orange",
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
//--- ヒートマップ
import "leaflet.heat/dist/leaflet-heat.js";

// @ is an alias to /src
export default {
    name: "SensorMap",
    components: {
        CompShotLog,
        CompDetectSummary,
        LMap,
        LTileLayer,
        LMarker,
        LControl,
        LPopup,
        LControlLayers,
        LPolygon,
        LGeoJson,
        LCircleMarker,
        LControlZoom,
        LControlScale,
    },
    //#########################################################################################
    data() {
        return {
            jwt: "",
            myInfo: [],
            dbSites: [],
            dbDevices: [],
            dbShotLogs: [],
            //---------------------
            geojson: null,
            geoOptions: {
                color: "blue",
                weight: 1.5,
                opacity: 1,
                fillColor: "blue",
                fillOpacity: 0.1,
            },
            //---------------------
            optDevices: [],
            selectDevices: null,
            iconManual: require("@/assets/icon-manual.png"),
            //---------------------
            heatmapData: null,
            heatmapObj: null,
            //---------------------
            showMarker: true,
            showCircle: true,
            showHeatmap: false,
            showMesh: false,
            //---------------------
            detectFilter: "",
            detectFilterItem: [
                { value: "", text: "すべて", icon: null },
                { value: "deer", text: "シカ", icon: require("@/assets/icon-dear.svg") },
                { value: "boar", text: "イノシシ", icon: require("@/assets/icon-boar.svg") },
                { value: "boarlet", text: "ウリ坊", icon: require("@/assets/icon-boarlet.svg") },
                { value: "bear", text: "クマ", icon: require("@/assets/icon-bear.svg") },
                { value: "monkey", text: "サル", icon: require("@/assets/icon-monkey.svg") },
            ],
            detectCount: 1,
            detectCountItem: [
                { value: 1, text: "1以上" },
                { value: 2, text: "2以上" },
                { value: 3, text: "3以上" },
                { value: 4, text: "4以上" },
                { value: 5, text: "5以上" },
            ],
            //---------------------
            polygons: [
                {
                    latlngs: [],
                    color: "red",
                    count: 5,
                },
            ],
            //---------------------
            circles: [
                // {
                //     center: [34.351, 136.595],
                //     radius: 10,
                //     color: "red",
                //     fillColor: "red",
                //     fillOpacity: 0.5,
                // },
                // {
                //     center: [34.351, 136.598],
                //     radius: 10,
                //     color: "red",
                //     fillColor: "red",
                //     fillOpacity: 0.5,
                // },
            ],
            //---------------------
            selectMeshLevel: 10000,
            optMeshLevel: [
                { value: 80000, text: "80km" },
                { value: 10000, text: "10km" },
                { value: 5000, text: "5km" },
                { value: 2000, text: "2km" },
                { value: 1000, text: "1km" },
                { value: 500, text: "500m" },
            ],
            //---------------------
            tileProviders: [
                {
                    name: "OpenStreet",
                    visible: true,
                    attribution: '<a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a>',
                    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                },
                {
                    name: "標準地図",
                    visible: false,
                    attribution: '<a target="_blank" href="https://maps.gsi.go.jp/development/ichiran.html">国土地理院</a>',
                    url: "https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png",
                },
                {
                    name: "衛星写真",
                    visible: false,
                    attribution: '<a target="_blank" href="https://maps.gsi.go.jp/development/ichiran.html">国土地理院</a>',
                    url: "https://cyberjapandata.gsi.go.jp/xyz/seamlessphoto/{z}/{x}/{y}.jpg",
                },
                {
                    name: "白地図",
                    visible: false,
                    attribution: '<a target="_blank" href="https://maps.gsi.go.jp/development/ichiran.html">国土地理院</a>',
                    url: "https://cyberjapandata.gsi.go.jp/xyz/blank/{z}/{x}/{y}.png",
                },
                // {
                //     name: "GoogleMap",
                //     visible: false,
                //     url: "https://mt3.google.com/vt/lyrs=r&x={x}&y={y}&z={z}",
                // },
                // {
                //     name: "GoogleMap",
                //     visible: false,
                //     url: "https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}",
                // },
            ],
            //---------------------
            center: {
                lat: 36.8444607407,
                lng: 138.273925,
            },
            zoom: 5,
            markers: [],
            //---------------------
            windowWidth: window.innerWidth, // 画面サイズ
            windowHeight: window.innerHeight, //画面サイズ
            modalDevice: {
                id: 0,
                name: "",
                jpgImg: "",
                date: "",
            },
            //---------------------
            dialog: false,
            dialogInfo: {
                name: "",
            },
            //dialogImages: [],
            //infiniteOffset: 0,
            //pageLimit: 3,
            //---------------------
            drawer: false,
            //dPicker: [this.$moment().add("-10", "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
            dPicker: this.$moment().format("YYYY-MM-DD"),
            //targetDate: [this.$moment().add("-10", "days").format("YYYY-MM-DD"), this.$moment().format("YYYY-MM-DD")],
            targetDate: this.$moment().format("YYYY-MM-DD"),
            maxDate: this.$moment().format("YYYY-MM-DD"),
            //---------------------
            dispCalender: false,
            //---------------------
            isLoading: false,
        };
    },
    //#########################################################################################
    computed: {
        targetDateText() {
            return this.targetDate;
            // if (this.targetDate.length > 1) {
            //     return this.targetDate.join(" ~ ");
            // } else {
            //     return this.targetDate;
            // }
        },
    },
    //#########################################################################################
    created: async function () {
        this.jwt = this.$localStorage.get("user-jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return true;
        }
        this.myInfo = JWT.decode(this.jwt);
        if (this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return true;
        }
        //---------------------------------
        this.isLoading = true;
        //---------------------------------
        if (this.$localStorage.get("map.circle_show")) this.showCircle = this.$localStorage.get("map.circle_show") == "true" ? true : false;
        if (this.$localStorage.get("map.circle_filter")) this.detectFilter = this.$localStorage.get("map.circle_filter");

        if (this.$localStorage.get("map.zoom")) this.zoom = Number(this.$localStorage.get("map.zoom"));
        if (this.$localStorage.get("map.lat")) this.center.lat = Number(this.$localStorage.get("map.lat"));
        if (this.$localStorage.get("map.lng")) this.center.lng = Number(this.$localStorage.get("map.lng"));
        if (this.$localStorage.get("map.layer")) {
            let layerName = this.$localStorage.get("map.layer");
            for (let layerObj of this.tileProviders) {
                if (layerObj.name == layerName) layerObj.visible = true;
                else layerObj.visible = false;
            }
        }
        //---------------------------
        // await this.axiosGetGeoJson24();
        const promiseDevices = this.axiosGetDevices();
        const promiseShotLogs = this.axiosGetShotLogs();
        await promiseDevices;
        await promiseShotLogs;
        this.countShot();
        this.dispMarker();
        this.dispHeatmap();
        this.dispMesh();
        this.dispCircle();
        //---------------------------
        this.isLoading = false;
        window.scrollTo(0, 0);
        //---------------------------------
    },
    //#########################################################################################
    mounted: function () {
        window.addEventListener("resize", this.handleResize);
    },
    //#######################################################
    beforeDestroy: function () {
        window.removeEventListener("resize", this.handleResize);
    },
    //#########################################################################################
    methods: {
        //====================================================
        baselayerChanged: function (layer) {
            //self.console.log(layer.name);
            this.$localStorage.set("map.layer", layer.name);
        },
        zoomUpdated: function (zoom) {
            //self.console.log(zoom);
            this.$localStorage.set("map.zoom", zoom);
            this.zoom = zoom;
        },
        centerUpdated: function (center) {
            //self.console.log(center);
            this.$localStorage.set("map.lat", center.lat);
            this.$localStorage.set("map.lng", center.lng);
            this.center.lat = center.lat;
            this.center.lng = center.lng;
        },
        //====================================================
        mapCSS: function () {
            // return "height: 500px; width: 300px;";
            //-----------------------------------
            let h = this.windowHeight;
            h = h - 66;
            if (h < 300) h = 300;
            return "height: " + h + "px;";
        },
        //====================================================
        handleResize: function () {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
        //====================================================
        async commitCalendar(date) {
            this.targetDate = date;
            this.dispCalender = false;
            //----------------------------------
            this.isLoading = true;
            await new Promise((r) => setTimeout(r, 1000));
            const promiseDevices = this.axiosGetDevices();
            const promiseShotLogs = this.axiosGetShotLogs();
            await promiseDevices;
            await promiseShotLogs;
            this.countShot();
            this.dispMarker();
            this.dispHeatmap();
            this.dispMesh();
            this.dispCircle();
            this.isLoading = false;
            //--------------------------------
        },
        //====================================================
        async openDialog(device_id) {
            //-------------------------
            for (let device of this.dbDevices) {
                if (device.id == device_id) {
                    this.dialogInfo = JSON.parse(JSON.stringify(device));
                    break;
                }
            }
            //this.dialogImages = [];
            this.dialog = true;
        },
        //====================================================
        async getImageBlob(device_id, path, imgObj) {
            await this.axios({
                responseType: "blob",
                method: "GET",
                url: "/web/api/image/",
                params: {
                    device_id: device_id,
                    path: path,
                },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                imgObj.jpgBlob = window.URL.createObjectURL(response.data);
            });
        },
        //====================================================
        async axiosGetGeoJson24() {
            await this.axios({
                method: "GET",
                url: "/web/api/geojson24",
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 10000,
            }).then((response) => {
                this.geojson = response.data;
            });
        },
        //====================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { "_order[name]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 10000,
            }).then((response) => {
                this.dbDevices = response.data.json;
                this.optDevices = [];
                this.optDevices.push({ value: null, text: "---" });
                for (let dev of this.dbDevices) {
                    this.optDevices.push({ value: dev.id, text: dev.name });
                }
            });
        },
        //====================================================
        async axiosGetShotLogs() {
            //----------------------------------
            let sdate = this.$moment(this.targetDate).add(-10, "days").format("YYYY-MM-DD");
            let edate = this.$moment(this.targetDate).add(1, "days").format("YYYY-MM-DD");
            //----------------------------------
            await this.axios({
                method: "GET",
                url: "/web/api/shot_logs",
                headers: { Authorization: "Bearer " + this.jwt },
                params: {
                    "received_at[EQGREAT]": sdate,
                    "received_at[SMALL]": edate,
                },
                timeout: 10000,
            }).then((response) => {
                this.dbShotLogs = response.data.json;
            });
            //-------------------------------
        },
        //====================================================
        // 写真枚数と「いのしし、しか、くま、さる」の検出数をまとめる
        //====================================================
        countShot() {
            //-------------------------------------------
            // 一次集計（カウントアップしやすく、取り出しやすい様、Object型で）
            let shotCount = {};
            for (let shot of this.dbShotLogs) {
                const device_id = shot["device_id"];
                const received_at = this.$moment(shot["received_at"]).format("YYYY-MM-DD");
                const strJson = shot["ai_analyzed"];
                //------------------------------------------
                const diffDays = this.$moment(this.targetDate).diff(this.$moment(received_at), "days");
                if (diffDays >= 10) continue;
                //------------------------------------------
                if (!shotCount[device_id]) {
                    shotCount[device_id] = [
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                        { shot_date: null, shot: 0, max_any: 0, max_deer: 0, max_boar: 0, max_bear: 0, max_monkey: 0, sum_any: 0, sum_deer: 0, sum_boar: 0, sum_bear: 0, sum_monkey: 0 },
                    ];
                }
                shotCount[device_id][diffDays]["shot"] += 1;
                shotCount[device_id][diffDays]["shot_date"] = received_at;
                //------------------------------------------
                if (strJson == null) continue;
                if (strJson == "[]") continue;
                const json = JSON.parse(strJson);
                //------------------------------------------
                for (const detect of json) {
                    shotCount[device_id][diffDays]["sum_any"] += 1;
                    const animal = detect["class"];
                    if (animal == "deer") shotCount[device_id][diffDays]["sum_deer"] += 1;
                    if (animal == "boar") shotCount[device_id][diffDays]["sum_boar"] += 1;
                    if (animal == "bear") shotCount[device_id][diffDays]["sum_bear"] += 1;
                    if (animal == "monkey") shotCount[device_id][diffDays]["sum_monkey"] += 1;
                }
                //------------------------------------------
                let max_any = 0;
                let max_deer = 0;
                let max_boar = 0;
                let max_bear = 0;
                let max_monkey = 0;
                for (const detect of json) {
                    max_any++;
                    const animal = detect["class"];
                    if (animal == "deer") max_deer += 1;
                    if (animal == "boar") max_boar += 1;
                    if (animal == "bear") max_bear += 1;
                    if (animal == "monkey") max_monkey += 1;
                }
                if (shotCount[device_id][diffDays]["max_any"] < max_any) shotCount[device_id][diffDays]["max_any"] = max_any;
                if (shotCount[device_id][diffDays]["max_deer"] < max_deer) shotCount[device_id][diffDays]["max_deer"] = max_deer;
                if (shotCount[device_id][diffDays]["max_boar"] < max_deer) shotCount[device_id][diffDays]["max_boar"] = max_boar;
                if (shotCount[device_id][diffDays]["max_bear"] < max_deer) shotCount[device_id][diffDays]["max_bear"] = max_bear;
                if (shotCount[device_id][diffDays]["max_monkey"] < max_deer) shotCount[device_id][diffDays]["max_monkey"] = max_monkey;
            }
            //self.console.log(shotCount);
            //----------------------------------
            for (const device of this.dbDevices) {
                const device_id = device["id"];
                device["ai_detect"] = {};
                device["shotAry"] = [];
                if (shotCount[device_id]) {
                    device["ai_detect"] = JSON.parse(JSON.stringify(shotCount[device_id]));
                }
                if (shotCount[device_id]) {
                    const tmpShotAry = [];
                    for (let obj of shotCount[device_id]) {
                        tmpShotAry.push(obj.shot);
                    }
                    device["shotAry"] = tmpShotAry.reverse();
                }
            }
        },
        //====================================================
        // マーカー（ピン）
        //====================================================
        dispMarker() {
            this.markers = []; //クリア
            if (!this.showMarker) return;
            //--------------------------------
            for (let dev of this.dbDevices) {
                if (!dev.gps_latitude || !dev.gps_longitude) continue;
                if (this.selectDevices == null || this.selectDevices == dev["id"]) this.markers.push(dev);
            }
        },
        //====================================================
        // ヒートマップのプラグインは、
        // コンポーネント化されたNPMパッケージが無いため
        // 直接操作
        //====================================================
        dispHeatmap() {
            // this.heatmapData = [];
            // let intensity = 30;
            // //------------------------------------------------
            // for (let shot of this.dbShotLogs) {
            //     if (!shot.gps_latitude || !shot.gps_longitude) continue;
            //     const lat = shot.gps_latitude;
            //     const lng = shot.gps_longitude;
            //     this.heatmapData.push([lat, lng, intensity]);
            // }
            //------------------------------------------------
            this.heatmapData = [];
            for (let device of this.dbDevices) {
                if (!device.gps_latitude || !device.gps_longitude) continue;
                const lat = device.gps_latitude;
                const lng = device.gps_longitude;
                const deer = device["ai_detect"]["sum_deer"];
                const boar = device["ai_detect"]["sum_boar"];
                const bear = device["ai_detect"]["sum_bear"];
                const monkey = device["ai_detect"]["sum_monkey"];
                const detectCount = deer + boar + bear + monkey;
                let intensity = 0;
                if (detectCount >= 1) intensity = 1;
                if (detectCount >= 3) intensity = 2;
                if (detectCount >= 6) intensity = 3;
                if (detectCount >= 9) intensity = 4;
                if (detectCount >= 12) intensity = 5;
                if (detectCount >= 15) intensity = 6;
                if (detectCount >= 20) intensity = 7;
                if (detectCount > 20) intensity = 8;
                this.heatmapData.push([lat, lng, intensity]);
            }
            //------------------------------------------------
            const heatmapOpt = {
                minOpacity: 1.0,
                maxZoom: 18,
                max: 2.0,
                radius: 20,
                blur: 15,
            };
            const map = this.$refs.map.mapObject;
            if (this.heatmapObj) {
                map.removeLayer(this.heatmapObj); //ヒートマップを一旦クリア
                this.heatmapObj = null;
            }
            if (this.showHeatmap) this.heatmapObj = self.L.heatLayer(this.heatmapData, heatmapOpt).addTo(map);
        },
        //====================================================
        // メッシュ地図
        //====================================================
        dispMesh() {
            const meshLevel = this.selectMeshLevel;
            //===================================================
            this.polygons = []; //クリア
            //===================================================
            let summaries = {};
            for (let shot of this.dbShotLogs) {
                if (!shot.gps_latitude || !shot.gps_longitude) continue;
                try {
                    const meshCode = japanmesh.toCode(shot.gps_latitude, shot.gps_longitude, meshLevel);
                    //----------------------------
                    if (!summaries[meshCode]) {
                        summaries[meshCode] = { meshCode: meshCode, count: 1 };
                    } else {
                        summaries[meshCode].count++;
                    }
                } catch {
                    self.console.log("GPS to MeshCode : Error!!");
                }
            }
            //===================================================
            let maxCount = 0;
            for (let idx in summaries) {
                const count = summaries[idx].count;
                if (maxCount < count) maxCount = count;
            }
            //===================================================
            for (let idx in summaries) {
                const meshCode = summaries[idx].meshCode;
                const count = summaries[idx].count;
                const bounds = japanmesh.toLatLngBounds(meshCode);
                let obj = {};
                let polygon = [];
                obj = bounds.getNorthEast();
                polygon.push([obj.lat, obj.lng]);
                obj = bounds.getNorthWest();
                polygon.push([obj.lat, obj.lng]);
                obj = bounds.getSouthWest();
                polygon.push([obj.lat, obj.lng]);
                obj = bounds.getSouthEast();
                polygon.push([obj.lat, obj.lng]);
                obj = bounds.getNorthEast();
                polygon.push([obj.lat, obj.lng]);
                //-----------------------------------------
                let opacity = (count / maxCount) * 0.5;
                opacity = Math.floor(opacity * 100) / 100;
                //self.console.log(polygon);
                this.polygons.push({
                    latlngs: polygon,
                    color: "red",
                    count: count,
                    opacity: opacity,
                });
                //-----------------------------------------
            }
            //self.console.log(this.polygons);
        },
        //====================================================
        // サークル
        //====================================================
        dispCircle() {
            //------------------------------------------------
            this.$localStorage.set("map.circle_show", this.showCircle);
            this.$localStorage.set("map.circle_filter", this.detectFilter);
            //------------------------------------------------
            if (!this.showCircle) return;
            this.showCircle = false;
            this.circles = [];
            //------------------------------------------------
            // デバイス単位のサークルデータを作成
            const colors = [
                { color: "#ffffff", opa: 0.4 },
                { color: "#00ffff", opa: 0.4 },
                { color: "#ffff00", opa: 0.4 },
                { color: "#ff0000", opa: 0.4 },
            ];
            //------------------------------------------------
            for (const device of this.dbDevices) {
                if (!device.gps_latitude || !device.gps_longitude) continue;
                const ai_detect = device["ai_detect"];
                const device_id = device["device_id"];
                // if (!ai_detect) continue;
                //for (let diffDays = ai_detect.length - 1; diffDays >= 0; diffDays--) {
                const aryLen = ai_detect.length;
                for (let diffDays in ai_detect) {
                    if (!ai_detect[diffDays]) continue;
                    const any = ai_detect[diffDays]["max_any"];
                    const deer = ai_detect[diffDays]["max_deer"];
                    const boar = ai_detect[diffDays]["max_boar"];
                    const bear = ai_detect[diffDays]["max_bear"];
                    const monkey = ai_detect[diffDays]["max_monkey"];
                    let detectCount = 0;
                    if (this.detectFilter == "") detectCount = any;
                    if (this.detectFilter == "deer") detectCount = deer;
                    if (this.detectFilter == "boar") detectCount = boar;
                    if (this.detectFilter == "bear") detectCount = bear;
                    if (this.detectFilter == "monkey") detectCount = monkey;

                    let colorNo = 0;
                    if (detectCount >= 1) colorNo = 1;
                    if (detectCount >= 3) colorNo = 2;
                    if (detectCount >= 5) colorNo = 3;
                    //-------------------------------
                    const lat = device.gps_latitude;
                    const lng = device.gps_longitude;
                    const radius = (aryLen - diffDays) * 5 + 10;
                    this.circles.push({
                        key: String(device_id) + "-" + String(diffDays),
                        center: [lat, lng],
                        radius: radius,
                        color: colors[colorNo]["color"],
                        weight: 0.0,
                        fillColor: colors[colorNo]["color"],
                        fillOpacity: colors[colorNo]["opa"],
                    });
                }
            }
            //------------------------------------------------
            this.showCircle = true;
        },
        //====================================================
    },
    //#########################################################################################
};
</script>
